export const en = {
    commonLabels: {
        courses: `Courses`,
        lessons: `Lessons`,
        chapters: `Chapters`,
        sections: `Sections`,
        course: `Course`,
        lesson: `Lesson`,
        chapter: `Chapter`,
        section: `Section`,
        success: `Success`,
        error: `Error`,
        action: `Action`,
        comment: `Comment`,
        ok: `Ok`,
        confirm: `Confirm`,
        confirmation: `Confirmation`,
        cancel: `Cancel`,
        submit: `Submit`,
        create: `Create`,
        add: `Add`,
        view: `View`,
        edit: `Edit`,
        update: `Update`,
        delete: `Delete`,
        back: `Back`,
        continue: `Continue`,
        save: `Save`,
        upload: `Upload`,
        select: `Select`,
        enter: `Enter`,
        required: `Required`,
        name: `Name`,
        description: `Description`,
        email: `Email`,
        emailId: `Email Id`,
        address: `Address`,
        phone: `Phone`,
        phoneNo: `Phone Number`,
        status: `Status`,
        editor: `Editor`,
        reviewer: `Reviewer`,
        owner: `Owner`,
        owners: `Owners`,
        saveAndContinue: `Save & Continue`,
        basicInformation: `Basic Information`,
        fundamentals: `Fundamentals`,
        courseOutline: `Course outline`,
        knowledgeGoals: `Knowledge Goals`,
        targetAudience: `Target Audience`,
        prerequisites: `Prerequisites`,
        trainingObjectives: `Training Objectives`,
        subjects: `Subjects`,
        useCases: `Use Cases`,
        subject: `Subject`,
        useCase: `Use Case`,
        ekcMatrix: `EKC Matrix`,
        contentDescription: `Content Description`,
        programPlan: `Program Plan`,
        export: `Export`,
        viewData: `View Data`,
        editData: `Edit Data`,
        deleteData: `Delete Data`,
        noRecordsFound: `No Records Found`,
        inactive: `Inactive`,
        loading: `Loading`,
        dontKnowWhereToStart: `Don't know where to start?`,
        overview: `Overview`,
        team: `Team`,
        role: `Role`,
        srNo: `Sr. No`,
        file: `File`,
        files: `Files`,
        value: `Value`,
        moveOnCourseMsg: `You are about to save this programme's basic information and moving forward towards creating courses. In order to ensure a proper setup for the rest of this programme please makes sure that all Basic information have been filled in.`,
        enterNewVersionName: `Enter New Version Name`,
        newVersion: `New Version`,
        pleaseEnterPrompt: `Please enter prompt`,
        areYouSure: `Are you sure?`,
        yes: `Yes`,
        no: `No`,
        wantToContinue: `Do you wanna continue?`,
        duplicateFileValidation: `File with same name already exists in this program: `,
        fileLimit: `You can upload a maximum of 25 files in each program`,
        invalidFile: `Invalid format`,
        versionError: `Version name cannot be empty.`,
        versionUnique: `Version name must be unique.`,
        addLesson: `Add Lesson`,
        editCourse: `Edit Course`,
        deleteCourse: `Delete Course`,
        addChapter: `Add Chapter`,
        editChapter: `Edit Chapter`,
        deleteChapter: `Delete Chapter`,
        editLesson: `Edit Lesson`,
        deleteLesson: `Delete Lesson`,
        addSection: `Add Section`,
        editSection: `Edit Section`,
        deleteSection: `Delete Section`,
        productionDashboard: `Production Dashboard`,
        draftVersionConfirmationMsg: `There is a draft version data available for this. Press 'Yes' to use the saved draft data or 'No' to proceed with the existing/blank data.`,
        maxLengthReached: `Maximum length reached`,
        maxLimitReached: `Maximum limit reached`,
        sessionExpire: `Your session has expired, Please login again.The system has not saved your unsaved data. Kindly re-login to continue your work.`,
        sessioTitle: `Session Timeout`,
        reLogin: `Re-Login`,
        storyboard: `Storyboard`,
        deleteFileConfirmation: `Are you sure want to delete File?`,
        invalidFormat: `Invalid format`,
        closeVersion: `Close Version`,
        confirmDelete: `Confirm Delete`,
        selectCourses: `Select Courses`,
        includeResource: `Do not include resources`,
        selectCourse: `Please Select Courses`,
        selected: `selected`,
        use: 'Use',
        assist: `assist`,
        sectionTitle: `Section Headline`,
        script: `Script`,
        presentation: `Presentation`,
        notes: `Directional notes`,
        resources: `Resources`,
    },
    otpLabels: {
        enterOtp: `Enter OTP`,
        didntReceiveOtp: `Didn't receive the OTP?`,
        clickToResend: `Click to resend`,
    },
    roleSelectionLabels: {
        selectRole: `Select Role`,
        logOut: `Log Out`,
    },
    homePageLabels: {
        home: `Home`,
        homePageDescription: `Here you can see all the Programmes you are a part of. You can sort after preference or create a new programme.`,
        homeReviewerView: `Here you can see all the Programmes you are a part of.`,
        createProgramme: `Create Programme`,
        searchInputPlaceholder: `Program Name,Course Name or Owner Name`,
        selectDateRange: `Select Date Range`,
        sortBy: `Sort By`,
        lastVisited: `Last Visited`,
        sortByAtoZ: `Sort By A-Z`,
        sortByZtoA: `Sort By Z-A`,
        sortByNewestFirst: `Sort By Newest First`,
        sortByOldestFirst: `Sort By Oldest First`,
        newestFirst: `Sort By Newest First`,
        viewInTop: `View from Top`,
        deleteProgramConfirmationMsg1: `Are you sure you want to delete this program`,
        deleteProgramConfirmationMsg2: `This action will archive the program, and it will no longer be visible in the Program Catalog. You can't restore it later if needed`,
        noResultsFound: `No results found`,
        createdOn: `Created on`,
        configureProgram: `Configure Program`,
        productionDashboard: `Production Dashboard`,
        draftVersionMessage: `You have saved draft data available.`,
        downloadFile: `Download file`,
        noCourseAssigned: `No Course assigned, please contact admin.`,
    },
    topBarLabels: {
        home: `Home`,
        overview: `Overview`,
        productionDashboard: `Production Dashboard`,
        team: `Team`,
        members: `Members`,
        knowledgeBank: `Knowledge Bank`,
        accountType: `Account Type`,
        myProfile: `My Profile`,
        logout: `Logout`,
        role: `Role`,
    },
    teamLabels: {
        listOfTeams: `List Of Teams`,
        addTeam: `Add team`,
        searchInputPlaceholder: `Team Name or Description`,
        teamName: `Team name`,
        teamDescription: `Description of Team`,
        numberOfMember: `Number of Member`,
        assignedCourse: `Assigned Course`,
        teamNameIsRequired: `Team Name is required`,
        selectTeamMember: `Select Team Member`,
        assignMember: `Assign Member`,
        assignRole: `Assign Role`,
        selectMember: `Select Member`,
        selectRole: `Select Role`,
        enterTeamDescription: `Enter Team Description`,
        assignTeam: `Assign Team`,
        selectCourse: `Select Course`,
        deleteTeamConfirmationMsg: `Are you sure want to Delete this Team`,
        invalidFormError: `Both user and roles are necessary!`,
        enterTeamName: `Enter Team Name`,
        teamMember: `Team Member`,
        assignCourse: `Assigned Course`,
    },
    membersLabels: {
        importMembers: `Import Members`,
        addMembers: `Add Member`,
        editMembers: `Edit Member`,
        listOfMembers: `List of Members`,
        searchInputPlaceholder: `Name, Email ID or Phone Number`,
        userId: `User ID`,
        organizationName: `Organization Name`,
        organizationRole: `Organization Role`,
        systemRole: `System Role`,
        resetPassword: `Reset Password`,
        selectFile: `Select File`,
        chooseFile: `Choose File`,
        noFileChosen: `No file chosen`,
        downloadSampleFile: `Download Sample File`,
        fileSelectionError: `No file selected. Please select the valid Excel or CSV file`,
        confirmMessage: `Confirm Message`,
        userDeactivateConfirmationMsg: `If you proceed with deactivating this user's status, they will be permanently removed from any teams. This action cannot be undone.`,
        selectSystemRole: `Select System Role`,
        systemRoleIsRequired: `System Role is required`,
        sendPassword: `Send Password`,
        sendPasswordConfirmMsg: `Are you sure want to send the password?`,
        send: `Send`,
        deleteMemberConfirmationMsg: `Are you sure want to delete this member`,
        importMembersErrorMsg: `Some members could not be imported. Please review and correct the Excel data, then retry.`,
        noneImportMembersErrorMsg: `None members were imported. Please review and correct the Excel data, then retry.`,
        maximumFileSize: `Maximum file size: 50 MB`,
        confirmContinue: `Are you sure you want to continue?`,
        fileSizeError: `File size exceeds 50 MB. Please upload a smaller file.`,
        fileInvalidError: `Invalid file format. Please upload an Excel or CSV file.`,
        zeroimportData: `None members were imported.`,
        downloadFile: `Download file`,
    },
    profileLabels: {
        profile: `Profile`,
        changePassword: `Change Password`,
        userId: `User ID`,
        organization: `Organization Name`,
        organizationRole: `Organization Role`,
        enterName: `Enter Name`,
        enterEmail: `Enter Email`,
        enterOrganization: `Enter Organization`,
        enterOrganizationRole: `Enter Organization Role`,
        enterAddress: `Enter Address`,
        nameIsRequired: `Name is required`,
        phoneIsRequired: `Phone is required`,
        userSavedImageNotSaved: `User saved successfully, Image not uploaded!`,
    },
    changePasswordLabels: {
        currentPassword: `Current Password`,
        currentPasswordIsRequired: `Current Password is required`,
        enterCurrentPassword: `Enter Current Password`,
        newPassword: `New Password`,
        passwordIsRequired: `Password is required`,
        enterNewPassword: `Enter New Password`,
        confirmNewPassword: `Confirm New Password`,
        enterConfirmNewPassword: `Enter Confirm New Password`,
        passwordUpercaseError: `Password must contain at least one uppercase letter.`,
        passwordLowercaseError: `Password must contain at least one lowercase letter.`,
        confirmPasswordIsRequired: `Confirm Password is required.`,
        passwordNotMatchError: `Confirm Password does not match with New Password`,
        passwordRequirements: `Password Requirements`,
        atLeast8charactersLong: `At least 8 characters long`,
        atLeast1Uppercase: `Must include one uppercase letter (A-Z)`,
        atLeast1Lowercase: `Must include one lowercase letter (a-z)`,
        atLeast1Number: `Must include one number (0-9)`,
        atLeast1SpecialCharacter: `Must include one special character (! @ # $ % ^ & * ( ))`,
    },
    forgotPasswordLabels: {
        forgotYourPassword: `Forgot your password?`,
        emailAddress: `Email Address`,
        enterEmailAddress: `Enter Email Address`,
        emailIsRequired: `Email is required`,
    },
    createProgramLabels: {
        createNewProgram: `Create New Programme`,
        allowOnlyFiles: `Allow only .jpg or .png file`,
        nameOfProgram: `Name of the programme`,
        enterProgramName: `Enter the programme name`,
        nameIsRequired: `Name is required`,
        programDescription: `Description of the programme`,
        showOnCatelogueCards: `This text will only show on the catalogue cards`,
        uploadCoverPhoto: `Upload Cover Photo`,
        addOwners: `Add Owners`,
        dragFile: `Drag a file or`,
        clickSelect: `click select`,
        fileSelectionPlaceholder: `to upload files you wish to use during the creation of your programme.`,
        editProgram: `Edit Programme`,
        fileSizeLimit20MB: `exceeds the 50 MB size limit.`,
        fileAlreadyUploaded: `is already uploaded.`,
        ownerRequiredMsg: `At least one owner is required.`,
        fileSizeLimit5MB: `Cover photo exceeds the 50 MB size limit.`,
        coverPhoto: `Cover Photo`,
        selectOwner: `Select Owners`,
        allowOnly: `Allow only`,
        deleteImgConfirmation: `Are you sure want to delete Image?`,
        allowFiles: `files.`,
        allowUpto: `Can upload maximum of 25 files. Each file size limits 50MB size.`,
        fileLimit: `You can upload a maximum of 25 files.`,
        uploadFailed: `Files not uploaded`,
        descriptionHint: `Maximum 4000 characters. Content above this limit may be trimmed.`,
        loading: `loading...`,
    },
    configureProgramLabels: {
        knowledgeGoalsPara1: `Knowledge goals define the essential knowledge, skills, and competencies that a learner should acquire upon completing the program. These goals ensure that all courses within the program contribute to a well-rounded learning outcome.`,
        knowledgeGoalsPara2: `Since a program consists of multiple courses, it's important to establish knowledge goals that encompass the entire curriculum. This helps maintain consistency and ensures learners achieve the intended proficiency.`,
        targetAudiencePara1: `The <b>target audience</b> refers to the specific group of learners for whom an eLearning program is designed. Identifying the target audience helps ensure that the content, language, and structure of the course are appropriate for their needs, prior knowledge, and learning goals.`,
        targetAudiencePara2: ``,
        prerequisitePara1: `<b>Prerequisite</b> knowledge refers to the foundational skills, concepts, or experiences that learners should have before starting a course or program. Establishing prerequisites ensures that learners can effectively engage with the material without unnecessary confusion or gaps in understanding.`,
        prerequisitePara2: ``,
        trainingObjectivesPara1: `<b>Training Objectives</b> define the specific skills, knowledge, or competencies that learners should acquire by the end of a course or training program. They serve as clear, measurable goals that guide both instructional design and learner progress, ensuring that training is focused and outcome-driven.`,
        trainingObjectivesPara2: `It will aid to Design assessments that accurately measure learning outcomes and provide learners with a clear path to acquiring and applying new knowledge. While knowledge goals define what learners should ultimately know, training objectives specify how they will get there, ensuring a structured and effective learning experience.`,
        useCasesPara1: `The <b>subject</b> defines the main topic or area of focus for a course or training program. It establishes the foundation for learning, ensuring that all content, activities, and assessments align with a central theme. A well-defined subject keeps the course structured, relevant, and engaging, helping learners stay focused and ensuring coherence throughout the program.`,
        useCasesPara2: `<b>Use cases</b> describe the real-world applications or scenarios in which the course content will be applied. They help instructional designers tailor materials, examples, and activities to match learners’ work environments, industries, or specific learning needs.`,
        ekcMatrixPara1: `The <b>EKC Matrix</b> is a structured framework that organizes subjects and use cases into a table, allowing course creators to define the level of learning required at each intersection. By categorizing learning objectives into different levels, the EKC Matrix ensures a clear progression of knowledge and skill development throughout a course or program.`,
        ekcMatrixPara2: `The matrix consists of three learning levels: <br> <b>Level 1 – Understand:</b> Learners should gain foundational knowledge, enabling them to comprehend the subject in a specific use case. This level focuses on awareness and conceptual understanding. <br> <b>Level 2 – Apply:</b> Learners should be able to use the acquired knowledge to solve problems or perform tasks related to the subject in a specific use case. This level emphasizes practical application.<br> <b>Level 3 – Create:</b> Learners should be able to generate new ideas, solutions, or content based on the knowledge gained from the course. This level focuses on innovation and mastery.`,
        contentDescriptionPara1: `<b>Content description</b> outlines the specific materials, topics, and learning resources included in a course or training program. It provides an overview of what learners will engage with, ensuring that the course structure is clear, organized, and aligned with learning objectives.`,
        contentDescriptionPara2: `Think of this as your free flow of ideas for the course. This is where you map out everything you want to cover, from key concepts and instructional materials to interactive elements and assessments. It’s your creative space to brainstorm how to best present the subject matter.`,
        assistCourseInitiatePara1: `Based on your input on the previous pages we can now create your course outline.`,
        assistCourseInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistCourseConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistCoursePromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Course outline.`,
        assistEditCourseInitiatePara1: `Based on your input on the previous pages we can now create your course data.`,
        assistEditCourseInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditCourseConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditCoursePromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Course data.`,
        assistLessonInitiatePara1: `Based on your input on the previous pages we can now create your lesson outline.`,
        assistLessonInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistLessonConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistLessonPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Lesson outline.`,
        assistEditLessonInitiatePara1: `Based on your input on the previous pages we can now create your lesson data.`,
        assistEditLessonInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditLessonConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditLessonPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Lesson data.`,
        assistChapterInitiatePara1: `Based on your input on the previous pages we can now create your chapter outline.`,
        assistChapterInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistChapterConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistChapterPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Chapter outline.`,
        assistEditChapterInitiatePara1: `Based on your input on the previous pages we can now create your chapter data.`,
        assistEditChapterInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditChapterConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditChapterPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Chapter data.`,
        assistSectionInitiatePara1: `Based on your input on the previous pages we can now create your section outline.`,
        assistSectionInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistSectionConfirmationPara1: `Hi, would you like some help to create an outline?`,
        assistSectionPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of an Section outline.`,
        assistEditSectionInitiatePara1: `Based on your input on the previous pages we can now create your section data.`,
        assistEditSectionInitiatePara2: `You can either populate them one by one or ask Eduscript assist to help you.`,
        assistEditSectionConfirmationPara1: `Hi, would you like some help to create data?`,
        assistEditSectionPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Section data.`,
        updateAiCourseConfirmation: `This action will replace the your course outline data of the {{versionName}} with AI response for course outline.`,
        updateAiLessonConfirmation: `This action will replace the your lesson outline data of the {{versionName}} with AI response for lesson outline.`,
        updateAiChapterConfirmation: `This action will replace the your chapter outline data of the {{versionName}} with AI response for chapter outline.`,
        updateAiSectionConfirmation: `This action will replace the your section outline data of the {{versionName}} with AI response for section outline.`,
        addAiCourseConfirmation: `This action will add the AI generated course outline data into the {{versionName}}.`,
        addAiLessonConfirmation: `This action will add the AI generated lesson outline data into the {{versionName}}.`,
        addAiChapterConfirmation: `This action will add the AI generated chapter outline data into the {{versionName}}.`,
        addAiSectionConfirmation: `This action will add the AI generated section outline data into the {{versionName}}.`,
        dontKnow: `Don't know`,
        whereToStart: `where to start?`,
        eduscriptAssist: `Eduscript assist`,
    },
    knowledgeBankLabels: {
        searchInputPlaceholder: `Search by Name, Type, Uploader`,
        createdBetween: `Created Between`,
        groupBy: `Group By`,
        program: `Program`,
        documentType: `Document Type`,
        creator: `Creator`,
        uploadFile: `Upload File`,
        totalFilesInAllProgram: `Total Files in all Program`,
        maxFileLimit: `File size should be less than 50MB`,
        size: `Size`,
        name: `Name`,
        mediaType: `Media Type`,
        createdBy: `Created By`,
        uploadedAt: `Uploaded At`,
        action: `action`,
        replaceData: `Replace Data`,
        downloadData: `Download Data`,
        selectProgram: `Select Programme`,
        browseAndUploadFile: `Browse and Upload File`,
        chooseFile: `Choose file`,
        noFileChosen: `No file chosen`,
        fileCaptured: `File Captured`,
        deleteMediaConfirmationMsg: `Are you sure want to Delete this Media`,
        upload: `Upload`,
        cancel: `Cancel`,
        loading: `loading...`,
        selectDateRange: `Select Date Range`,
        fileLimit: `You can upload a maximum of 25 files in each program.`,
    },
    overviewLabels: {
        viewProgram: `View Summary Program`,
        program: `Programme`,
        selectProgram: `Select Programme`,
        noResultFound: `No result found`,
        addCourse: `Add Course`,
        exportProgram: `Export`,
        fundamental: `Fundamental`,
        comment: `Comment`,
        loading: `loading...`,
        noCourseAvailable: `No Course Available`,
        pleaseSelectProgram: `Please select Programme`,
        courseDeleteConfirmation1: `Are you sure you want to remove this course`,
        courseDeleteConfirmation2: `This action will permanently delete the course and all associated Lessons, Chapters, and Sections. This action cannot be undone.`,
        lessonDeleteConfirmation1: `Are you sure you want to remove this lesson`,
        lessonDeleteConfirmation2: `This action will permanently delete the lesson and all associated Chapters and Sections. This action cannot be undone.`,
        chapterDeleteConfirmation1: `Are you sure you want to remove this chapter`,
        chapterDeleteConfirmation2: `This action will permanently delete the chapter and all associated Sections. This action cannot be undone.`,
        sectionDeleteConfirmation1: `Are you sure you want to remove this section`,
        sectionDeleteConfirmation2: `This action will permanently delete the Sections. This action cannot be undone.`,
        chapterValidation: `Chapter not moved to another chapter`,
        sectionValidation: `Section not moved to another section`,
        withinCourseValidation: `Reordering is allowed only within the same Course.`,
        informationShow: `Reordering is allowed only within the same Course. Sections can be moved between Chapters, and Chapters can be moved between Lessons. However, items cannot change levels—Sections cannot become Chapters, and Chapters cannot become Lessons`,
        withinChapterValidation: `Section not moved to another lesson`,
        sectionwithChapterValidation: `Section not moved to another chapter`,
        noSectionFound: `No Section Found!`,
        noPermissionToAddComment: `There are no comments present in the section and you don't have permission to add any comment.`,
    },
    ekcMatrixLabels: {
        addSubjects: `Add Subjects`,
        addUsecases: `Add Usecases`,
        usecaseError: `At least one subject and one use case are required if any is added!`,
        understand: `Understand`,
        apply: `Apply`,
        editUsecases: `Edit Usecases`,
        noData: `No data`,
        noDataMsg: `Please create subjects and use cases to continue`,
    },
    courseLabels: {
        courseOutline: `Course outline`,
        courseTitle: `Course Title`,
        enterCourseTitle: `Enter Course Title`,
        courseDescription: `Course Description`,
        enterCourseDescription: `Enter Course Description`,
        manageTeamAndMembers: `Manage Team & Members`,
        assignTeamAndMembers: `Assign Team & Member`,
        assignTeams: `Assign Teams`,
        assignedTeams: `Assigned Teams`,
        assignedMembers: `Assigned Members`,
        selectMemberAndRole: `Select member and role`,
        memberName: `Member Name`,
        selectTeam: `Select Team`,
        courseTitleRequired: `Course Title is required.`,
        courseDescriptionLimitError: `Course Description has to be maximum 4000 characters`,
        wantToContinue: `Do you wanna continue?`,
        continueConfirmation: `You are about to save this programme's basic information and moving forward towards creating courses. In order to ensure a proper setup for the rest of this programme please makes sure that all Basic information have been filled in.`,
        newCourse: `New Course`,
        removeCourse: `Remove Course`,
    },
    lessonLabels: {
        lessonTitle: `Lesson Title`,
        enterLessonTitle: `Enter Lesson Title`,
        lessonDescription: `Lesson Description`,
        enterLessonDescription: `Enter Lesson Description`,
        newLesson: `New Lesson`,
        removeLesson: `Remove Lesson`,
    },
    chapterLabels: {
        chapterTitle: `Chapter Title`,
        enterChapterTitle: `Enter Chapter Title`,
        chapterDescription: `Chapter Description`,
        enterChapterDescription: `Enter Chapter Description`,
        newChapter: `New Chapter`,
        removeChapter: `Remove Chapter`,
    },
    sectionLabels: {
        sectionTitle: `Section Headline`,
        enterSectionTitle: `Enter Section Headline`,
        sectionDescription: `Section Storyboard`,
        enterSectionDescription: `Enter Section Storyboard`,
        newSection: `New Section`,
        removeSection: `Remove Section`,
        deleteMessage: `Are you sure you want to delete this section? This action cannot be undone.`,
        scriptPlaceholder: `Type or paste your script here...`,
        scriptWriting: `Script Writing`,
        scriptSegmenting: `Script Segmenting`,
        allowOnly: `Allow only`,
        allowUpto: `Can upload maximum of 25 files. Each file size limits 50MB size.`,
        fileLimit: `You can upload a maximum of 25 files.`,
        mediaUpload: `Media File Upload`,
        fileAlreadyUploaded: `is already uploaded.`,
        deleteSectionConfirmationMessage: `Are you sure you want to remove this segment?`,
        sectionScript: `Section Script`,
        downloadData: `Download Data`,
        scriptAiAssistInitiatePara1: `Based on your input on the previous pages we can now create your script data.`,
        scriptAiAssistInitiatePara2: `You can ask Eduscript assist to help you.`,
        scriptAiAssistConfirmationPara1: `Hi, would you like some help to create data?`,
        scriptAiAssistPromptPara1: `Great! Based on the information you have provided i will give you a suggestion of a Script data.`,
        assist: ` Eduscript Assist`,
        uploadMedia: `Upload Media`,
        typehere: `Type Note here...`,
        fileSizeLimit20MB: `Cover photo exceeds the 50 MB size limit.`,
        uploadFailed: `Files not uploaded`,
        dragFile: `Drag a file or`,
        clickSelect: `click select`,
        fileSelectionPlaceholder: `to upload files you wish to use during the creation of your programme.`,
        allowFiles: `files.`,
        updateScriptConfirmationMessage: `Are you sure you want to update the script of "{{sectionName}}" section?`,
        deleteData: `Delete Data`,
        removeData: `Remove Data`,
        fileSizeLimit: `File exceeds the 50 MB size limit.`,
    },
    roleLabels: {
        listOfRoles: `List of Roles`,
        addNew: `Add New`,
        searchInputPlaceholder: `Role name or description`,
        roleName: `Role Name`,
        updateDate: `Update Date`,
        deleteRoleConfirmation: `Are you sure you want to delete this role?`,
        deactivateRoleConfirmation: `If you want to deactivate the status of this role, please ensure that all users assigned to this role are reassigned to a different role first. Users must not be left without a role before deactivation.`,
    },
    productionDashboardLabels: {
        program: `Programme`,
        selectProgram: `Select Programme`,
        cancel: `Cancel`,
        selectCourses: `Select Courses`,
        selectLessons: `Select Lessons`,
        selectChapters: `Select Chapters`,
        selectSections: `Select Sections`,
        section: `Section`,
        filterPresentations: `Filter Presentations`,
        exportAsExcel: `Export as excel`,
        applyFilters: `Apply Filters`,
        scriptOrSequenceOfEvent: `Script/Sequence of Events`,
        presentations: `Presentations`,
        presentation: `Presentation`,
        resourcesCount: `Resources count`,
        directionalNotes: `Directional Notes`,
        resources: `Resources`,
        productionMoments: `Production Moments`,
        clearFilters: `Clear Filters`,
        noData: `No Data Available`,
        loading: `Loading...`,
        atLeastOneSectionRequired: `Please select atleast one section to continue!`,
        pieChartTitle: `Presentation Type of Distribution`,
    },
    commentLabels: {
        comments: `Comments`,
        sectionName: `Section Name`,
        sectionHeadline: `Section Headline`,
        viewLess: `View Less`,
        viewMore: `View More`,
        noCommentsAvailable: `No Comments available`,
        selectSection: `Select Section`,
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        by: 'By',
        pleaseSelectSection: `Please select Section`,
        deleteCommentConfirmation: `Are you sure you want to delete this comment?`,
        acceptCommentConfirmation: `Are you sure you want to accept this comment?`,
        rejectCommentConfirmation: `Are you sure you want to reject this comment?`,
        discardCommentConfirmation: `Are you sure you want to discard this comment?`,
    },
    createCourseLabels: {
        title: `Create your course`,
        subtitle: `Describe what you want to create, then upload your source material. EduScript generates the full structure.`,
        courseTitleLabel: `Course title`,
        courseTitlePlaceholder: `Give your course a name...`,
        courseTitleHint: `Optional — we'll suggest a title from your brief if you leave this empty.`,
        whatToCreate: `What do you want to create?`,
        descriptionHelp: `Give the AI a clear brief — describe the topic, audience, and goals. The more detail you provide, the better the generated course will match your intent.`,
        descriptionHint: `Maximum 4000 characters. Content above this limit may be trimmed by the AI.`,
        contentType: `Content type`,
        createFromDocument: `Create from document`,
        sopToElearning: `SOP to eLearning`,
        trainingCourse: `Training course`,
        instructionalVideo: `Instructional video`,
        productMarketing: `Product training`,
        language: `Output language`,
        english: `English`,
        swedish: `Swedish`,
        knowledgeLevel: `Knowledge level`,
        knowledgeLevelHelp: `Shapes vocabulary, pacing, depth, and interaction`,
        beginner: `Beginner`,
        beginnerDesc: `No prior knowledge required`,
        intermediate: `Intermediate`,
        intermediateDesc: `Familiar with basics`,
        advanced: `Advanced`,
        advancedDesc: `Deep domain experience`,
        microCourse: `Micro course`,
        microCourseHelp: `Generate shorter, focused content with fewer modules`,
        addQuiz: `Add quiz`,
        addQuizHelp: `Generate quizzes and exercises from your source material`,
        thumbnail: `Course thumbnail`,
        uploadImage: `Upload image`,
        aiGenerate: `AI Generate`,
        aiGenerateImage: `AI Generate Image`,
        aiGeneratingImage: `Generating image...`,
        aiImageGenerated: `Image generated successfully`,
        aiImageGenerationFailed: `Failed to generate image`,
        aiImageModalTitle: `AI Generated Course Thumbnail`,
        selectImage: `Select`,
        regenerateImage: `Regenerate`,
        provideDescriptionFirst: `Please provide a course description first (minimum 40 characters)`,
        generatingPleaseWait: `Generating, please wait...`,
        sourceMaterial: `Source material`,
        sourceMaterialHelp: `Optional — upload reference material that EduScript can use as context when generating your course.`,
        describeFirst: `Describe first`,
        supportedFormats: `Supported: PDF, DOCX, PPTX, XLSX, TXT`,
        fileLimits: `Max 50 MB per file, up to 25 files`,
        generateCourse: `Generate course`,
        generating: `Generating...`,
        charMinimum: `{{count}} / 40 characters minimum`,
        locked: `Locked`,
        whatHappensNext: `What happens next`,
        aiWillGenerate: `EduScript will generate:`,
        willGenerateStructure: `Course structure with modules and sections`,
        willGenerateScripts: `Scripts and storyboards for each section`,
        willGenerateChecks: `Knowledge checks and reinforcement moments`,
        willGenerateLevel: `Level-appropriate vocabulary and pacing`,
        canEditAfter: `You can edit, reorganize, and regenerate everything in the next step.`,
        generatingCourse: `Generating your course`,
        generatingMessage: `AI is analyzing your description and creating course suggestions...`,
        generationHint: `This may take a moment. Please don't close this tab.`,
    },
    customizeCourseLabels: {
        title: `Shape your course`,
        subtitle: `Here are the lessons EduScript generated for your course. Edit, add, or remove lessons — then refine with AI if needed.`,
        yourBrief: `Your brief`,
        courseOutline: `Lesson outline`,
        courseNamePlaceholder: `Lesson name`,
        courseDescPlaceholder: `What this lesson covers`,
        done: `Done`,
        addCourse: `Add a lesson`,
        refineTitle: `Refine with AI`,
        refineHelp: `Describe what you want to change. For example: "Add a lesson about safety" or "Make descriptions shorter".`,
        refinePlaceholder: `Tell EduScript what to adjust...`,
        refineButton: `Refine`,
        back: `Back`,
        continue: `Continue`,
        saving: `Saving…`,
        generationTitle: `Building your manuscript`,
        generationHint: `This may take a few minutes. Please do not close the tab.`,
        genPreparing: `Preparing generation…`,
        genLessons: `Generating lessons for course`,
        genChapters: `Generating chapters for lesson`,
        genSections: `Generating sections for chapter`,
        genDone: `Manuscript ready.`,
        genOf: `of`,
    },
    manuscriptLabels: {
        stepName: `Manuscript`,
        title: `Read through your course`,
        subtitle: `Read the full manuscript like a book. Edit any section directly or ask AI to refine it. When you've reviewed everything, approve to move into production.`,
        tableOfContents: `Contents`,
        lessonsLabel: `lessons`,
        lessonLabel: `Lesson`,
        storyboardNote: `Storyboard`,
        endOfManuscript: `End of manuscript`,
        back: `Back to Customize`,
        approve: `Approve manuscript`,
        approveSubtext: `Sign off and move to production`,
        reviewed: `reviewed`,
        markReviewed: `Mark as reviewed`,
        allReviewed: `All sections reviewed`,
        sectionsRemaining: `sections left to review`,
        learningOutcome: `Learning outcome`,
        teachingApproach: `Pedagogical approach`,
        clickToEdit: `Click to edit`,
        clickToEditHeadline: `Click to edit the headline`,
        clickToEditScript: `Click to edit the script`,
        clickToEditStoryboard: `Click to edit the storyboard`,
        editHint: `Press Esc to cancel`,
        doneEditing: `Done`,
        suggestWithAi: `Refine section with AI`,
        refineWithAi: `Refine this section with AI`,
        refineHelp: `Describe how you want this section changed. For example: "Make it shorter" or "Add a real-world example".`,
        refinePlaceholder: `What should AI change?`,
        refineButton: `Refine`,
        refineWhat: `What to refine:`,
        refineScript: `Script`,
        refineStoryboard: `Storyboard`,
        refineBoth: `Both`,
        changeFormat: `Click to change format`,
        chooseFormat: `Choose content format`,
        chooseFormatHelp: `Pick the best way to deliver this section. EduScript suggests formats that fit the content — but you can pick any of them.`,
        recommendedForThisSection: `Recommended for this section`,
        recommendedHelp: `These formats fit the script and storyboard you wrote. Start here if you're unsure.`,
        close: `Close`,
        searchFormats: `Search formats by name or purpose...`,
        clearSearch: `Clear`,
        noFormatsFound: `No formats match your search.`,
        currentLabel: `Current`,
        bestForLabel: `Best for`,
        showContents: `Contents`,
        hideContents: `Close`,
        resetReviews: `Reset reviews`,
        exportPdf: `Export PDF`,
        exporting: `Exporting…`,
    },
    phasesLabels: {
        manuscript: `Manuscript`,
        production: `Production`,
        delivery: `Delivery`,
    },
    productionLabels: {
        title: `Production board`,
        subtitle: `Each block is a piece of media to produce. Upload your asset, mark it as ready, and move on. You can come back anytime — your progress is saved.`,
        contents: `Contents`,
        sectionLabel: `Section`,
        blocksLabel: `blocks`,
        blockLabel: `Block`,
        statusPending: `Pending`,
        statusInProgress: `In progress`,
        statusApproved: `Approved`,
        markPending: `Mark as pending`,
        markInProgress: `Mark in progress`,
        markApproved: `Mark as approved`,
        uploadAsset: `Upload your own`,
        replaceAsset: `Replace`,
        generateWithAi: `Generate with AI`,
        regenerateWithAi: `Regenerate with AI`,
        uploading: `Uploading...`,
        generating: `Generating...`,
        generationFailed: `Generation failed`,
        retry: `Retry`,
        textOnly: `Text only — no asset needed`,
        notes: `Production notes`,
        notesPlaceholder: `Add a note for the production team...`,
        progressLabel: `Production progress`,
        approvedCount: `approved`,
        back: `Back to Manuscript`,
        finalize: `Finalize production`,
        finalizeSubtext: `When all blocks are approved, move to Delivery`,
        allBlocksApproved: `All blocks approved`,
        blocksRemaining: `blocks left to approve`,
        noSectionSelected: `Select a section to see its blocks`,
    },
    dashboardLabels: {
        welcome: `Welcome`,
        subtitle: `Pick up where you left off, or start something new.`,
        createNew: `Create new course`,
        creating: `Creating...`,
        createFirst: `Create your first course`,
        inProgress: `In progress`,
        completed: `Completed`,
        continueAction: `Continue`,
        openAction: `Open`,
        allCourses: `All courses`,
        searchPlaceholder: `Search courses...`,
        sortNewest: `Newest first`,
        sortOldest: `Oldest first`,
        sortAZ: `A — Z`,
        sortZA: `Z — A`,
        courses: `courses`,
        lessons: `lessons`,
        untitled: `Untitled course`,
        loadMore: `Load more`,
        subtitleEmpty: `Create your first course and let AI help you build it.`,
        subtitleInProgress: `You have`,
        emptyTitle: `No courses yet`,
        emptySubtitle: `Create your first course and let AI help you build it.`,
        noResults: `No courses match your search.`,
        clearSearch: `Clear search`,
        lastVisited: `Last visited`,
        showDetails: `Show details`,
        createdLabel: `Created`,
        lastUpdated: `Last updated`,
        ownersLabel: `owners`,
        justNow: `Just now`,
        status_draft: `Draft`,
        status_editing: `Editing`,
        status_in_review: `In review`,
        status_in_production: `In production`,
        status_delivered: `Delivered`,
        manuscript_approved: 'Manuscript Approved',
    },
    stepsLabels: {
        create: `Create`,
        customize: `Customize`,
        studio: `Studio`,
    },
    walletLabels: {
        navLabel: `Credits`,
        title: `Credits`,
        subtitle: `Your AI credit balance and activity.`,
        creditsUnit: `credits`,
        available: `Available`,
        reserved: `Reserved`,
        used: `Used`,
        totalCredited: `Total credited`,
        statusHealthy: `Healthy`,
        statusWarning: `Running low`,
        statusExhausted: `Out of credits`,
        warningMessage: `You have used {{percent}}% of your credits. Request more before you run out.`,
        exhaustedMessage: `You have no credits left. AI generation is paused until you request more.`,
        tabUsage: `Usage`,
        tabTransactions: `Transactions`,
        tabRequests: `Credit requests`,
        colDate: `Date`,
        colAction: `Action`,
        colModel: `Model`,
        colStatus: `Status`,
        colCredits: `Credits`,
        colProviderTokens: `Provider tokens`,
        colType: `Type`,
        colDescription: `Description`,
        colAmount: `Amount`,
        colBalanceAfter: `Balance after`,
        colRequested: `Requested`,
        colApproved: `Approved`,
        colReason: `Reason`,
        colAdminNote: `Administrator note`,
        noUsage: `No AI activity yet.`,
        noTransactions: `No transactions yet.`,
        noRequests: `You have not requested credits yet.`,
        requestTitle: `Request more credits`,
        requestAmount: `Credits needed`,
        requestReason: `Reason`,
        requestReasonPlaceholder: `Tell the administrator what you need the credits for`,
        submitRequest: `Submit request`,
        submitting: `Submitting...`,
        requestSubmitted: `Your credit request has been submitted.`,
        pendingRequestNotice: `You have a pending request. You can submit another once it has been reviewed.`,
        amountInvalid: `Enter a whole number of 1 or more.`,
        reasonRequired: `Reason is required.`,
        reasonTooLong: `Reason must be 250 characters or fewer.`,
        loadError: `Could not load your credits. Please try again.`,
        retry: `Try again`,
        viewCredits: `View credits`,
        typeInitialCredit: `Initial credit`,
        typeCredit: `Credits added`,
        typeDebit: `Credits used`,
        typeOther: `Adjustment`,
        aiGeneration: `AI generation`,
        requestPending: `Pending`,
        requestApproved: `Approved`,
        requestRejected: `Rejected`,
        requestCancelled: `Cancelled`,
        usageInProgress: `In progress`,
        usageCompleted: `Completed`,
        usageFailed: `Failed`,
        usageProcessing: `Processing`,
        actionCourseCreate: `Course generation`,
        actionCourseUpdate: `Course revision`,
        actionLessonCreate: `Lesson generation`,
        actionLessonUpdate: `Lesson revision`,
        actionChapterCreate: `Chapter generation`,
        actionChapterUpdate: `Chapter revision`,
        actionSectionCreate: `Section generation`,
        actionSectionUpdate: `Section revision`,
        actionScriptCreate: `Script generation`,
        actionScriptUpdate: `Script revision`,
        actionProgramSummarize: `Program summary`,
        actionRagDocumentIngest: `Document processing`,
    },
    superAdminLabels: {
        consoleTitle: `Super Admin`,
        consoleSubtitle: `Credit management`,
        signInTitle: `Super Admin sign in`,
        email: `Email`,
        password: `Password`,
        signIn: `Sign in`,
        signingIn: `Signing in...`,
        signInFailed: `Invalid email or password.`,
        emailRequired: `Enter a valid email address.`,
        passwordRequired: `Password is required.`,
        signOut: `Sign out`,
        loadError: `Could not load this data. Please try again.`,
        retry: `Try again`,
        tabRequests: `Credit requests`,
        tabWallet: `User wallet`,
        tabUsage: `Usage`,
        tabPolicy: `Policy`,
        tabReconciliation: `Reconciliation`,
        colUser: `User ID`,
        colActions: `Actions`,
        statusFilter: `Status`,
        statusAll: `All`,
        approve: `Approve`,
        reject: `Reject`,
        viewWallet: `View wallet`,
        approveTitle: `Approve credit request`,
        rejectTitle: `Reject credit request`,
        creditsToGrant: `Credits to grant`,
        noteToUser: `Note to user`,
        optional: `optional`,
        rejectNoteRequired: `A note explaining the rejection is required.`,
        noteTooLong: `Note must be 250 characters or fewer.`,
        confirm: `Confirm`,
        cancel: `Cancel`,
        userId: `User ID`,
        lookUp: `Look up`,
        userIdOrEmail: `User ID or email`,
        userLookupInvalid: `Enter a user ID (1 or more) or part of an email (up to 255 characters).`,
        noUserMatch: `No active user has an email containing that text.`,
        selectUser: `Several users match. Choose one:`,
        userIdInvalid: `Enter a user ID (a whole number of 1 or more).`,
        userFilterInvalid: `Enter a user ID (1 or more) or part of an email (up to 255 characters).`,
        adjustTitle: `Adjust credits`,
        addCredits: `Add credits`,
        removeCredits: `Remove credits`,
        amount: `Credits`,
        reason: `Reason`,
        reasonRequired: `Reason is required.`,
        amountInvalid: `Enter a whole number of 1 or more.`,
        apply: `Apply`,
        applying: `Applying...`,
        confirmRemoveTitle: `Remove credits?`,
        confirmRemoveMessage: `Remove {{amount}} credits from user {{userId}}? This is recorded in the ledger permanently; it can only be offset by a new adjustment.`,
        filterByUser: `Filter by user ID or email`,
        applyFilter: `Apply`,
        clearFilter: `Clear`,
        warningThreshold: `Low-balance warning at (% of credits used)`,
        thresholdInvalid: `Enter a whole number from 1 to 100.`,
        initialCredits: `Initial credits for new users`,
        initialCreditsHint: `Granted once when a user is created. 1 credit = 1 provider token.`,
        initialCreditsInvalid: `Enter a whole number from 1 to 1000000000.`,
        actionEstimatesTitle: `Credits held per AI action (estimate)`,
        actionEstimatesHint: `Held before each generation; the generation is blocked if the balance is lower. Afterwards the provider tokens actually used are charged (1 credit = 1 token) and unused credits are returned. Program summaries and knowledge-bank processing are never blocked; their estimate is charged only if no usage is reported.`,
        estimateInvalid: `Enter a whole number from 1 to 1000000.`,
        save: `Save`,
        saving: `Saving...`,
        runCheck: `Run check`,
        running: `Checking...`,
        reconciliationIntro: `Read-only check that every wallet agrees with its ledger. Corrections are made with credit adjustments, never by editing data.`,
        releaseHold: `Release`,
        releaseAllHolds: `Release all expired holds`,
        releasing: `Releasing...`,
        confirmReleaseTitle: `Release expired hold?`,
        confirmReleaseMessage: `Return {{amount}} held credits to user {{userId}}? The generation expired without completing, so it is marked as failed and is not charged.`,
        confirmReleaseAllMessage: `Release {{count}} expired holds and return their credits to the users? Their generations expired without completing, so they are marked as failed and are not charged.`,
        clean: `Clean: every wallet agrees with its ledger.`,
        notClean: `Mismatches found. Investigate before correcting with an adjustment.`,
        checkedAt: `Checked at`,
        errorsTitle: `Errors`,
        warningsTitle: `Warnings`,
        rowsShown: `Showing at most {{limit}} rows per check.`,
        noRows: `None`,
        check_wallet_mismatches: `Wallet does not match ledger`,
        check_charged_mismatch: `Charge does not match ledger`,
        check_uncovered_usage: `Usage not charged (balance reached 0)`,
        check_debit_without_completed_request: `Charge without a completed generation`,
        check_unexpected_ledger_types: `Unexpected ledger entry types`,
        check_stale_reservations: `Expired holds still active`,
        check_stuck_requests: `Generations stuck in progress`,
    },
} as const;
